import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      window.history.pushState(null, '', href);
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1741940365113-4c77bdc325e0)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-amber-800/20 backdrop-blur-sm border border-amber-800/30 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-amber-400" />
            <span className="text-amber-400 text-sm font-medium">Expert African Braiding Artistry</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            African Braids in Zürich — Authentic Styles That Tell Your Story
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-gray-200 mb-8 leading-relaxed">
            Professional African braiding in Zollikerberg, Zürich, specializing in Box Braids, Knotless Braids, Boho Braids, Cornrows and more. Over 10 years of experience creating beautiful protective styles while caring for your natural hair.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="bg-amber-800 hover:bg-amber-900 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => scrollToSection('#contact')}
            >
              Book Your Appointment
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-2 border-white text-white hover:bg-white hover:text-amber-800 text-lg px-8 py-6 backdrop-blur-sm transition-all duration-300"
              onClick={() => scrollToSection('#gallery')}
            >
              View Our Work
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-8 mt-12 pt-12 border-t border-white/20">
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-amber-400 mb-1">10+</div>
              <div className="text-gray-300 text-sm sm:text-base">Years Experience</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-amber-400 mb-1">2000+</div>
              <div className="text-gray-300 text-sm sm:text-base">Happy Clients</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default Hero;
